module.exports = new __parcel__URL__("oco--dataset-cover.f964f42b.jpg").toString();